export function Error() {
  return (
    <p className='error'>
      <span>💥</span> There was an error fetching questions.
    </p>
  );
}
